export enum UserErrorOrigin {
    GET_USERS = 'GET_USERS',
    UPSERT_USER = 'UPSERT_USER',
    GET_USER_ROLES = 'GET_USER_ROLES',
    GET_USER_BY_ID = 'GET_USER_BY_ID',
    UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD',
}

export interface UserError {
    type: UserErrorOrigin,
    detail: any
}

export interface UpdatePasswordRequest {
    processType: "ASSIGN" | "CHANGE"
    userIdProcess: number
    newPassword: string
    oldPassword?: string
}